<div class="row align-items-center mb-3" *ngIf="enableToggleButton">
  <div class="col-sm-4">
    <button class="btn btn-labeled mr-1 mb-2 {{ fileButtonClass }}" 
            (click)="fileInput.click()"
            [disabled]="uploadedFiles.length !== 0 || working">
      <span class="btn-label">
        <i style="font-size: 1.5em;" class="fa {{ iconClass }}"></i>
      </span>
      <span>{{ title }}</span>
    </button>
  </div>
  
  <div class="list-group col-sm-5">
    <label class="list-group-item list-group-item-action m-0" *ngFor="let file of uploadedFiles">
      {{ file.name }}
      <i style="font-size: 1.5em; cursor: pointer;" 
         class="fa fa-trash float-right text-danger" 
         (click)="deleteFile(file)"></i>&nbsp;
    </label>
  </div>
  
  <div class="col-sm-3 d-flex justify-content-end" *ngIf="enableSubmitButton">
    <button class="btn btn-labeled mr-1 mb-2 btn-outline-success" 
            (click)="onSendClick()"
            [disabled]="uploadedFiles.length === 0 || saving || working">
      <span class="btn-label">
        <i style="font-size: 1.5em;" class="fa fa-save" *ngIf="!saving"></i>
        <i style="font-size: 1.5em;" class="fa fa-circle-o-notch fa-spin" *ngIf="saving"></i>
      </span>
      <span>{{ submitButtonText }}</span>
    </button>
  </div>
  
  <input type="file" 
         (change)="onFileSelect($any($event).target.files)" 
         #fileInput 
         hidden
         [accept]="acceptFormats" />
</div>